import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { QueryRoute, RouteStore } from 'bernie-core';
import { Layer } from 'bernie-view';
import { LocalizedText } from 'bernie-l10n';
import { ClickTracker } from 'bernie-analytics';
import { SearchResultsStore } from 'stores/search-results-store';
import { FiltersDialog } from './filters-dialog';

export interface FiltersToggleProps {
  className?: string;
  routeStore?: RouteStore;
  searchResults?: SearchResultsStore;
  showActions?: boolean;
  isActive: boolean;
  buttonComponent: React.ReactNode;
  isFullWidth: boolean;
  label: string;
  a11yMessage: string;
  rfrr: string;
  stid: string;
}

@inject('layerManager', 'routeStore', 'searchResults')
@observer
export class FiltersToggle extends React.Component<FiltersToggleProps> {
  private filtersBtn: React.RefObject<HTMLElement>;

  constructor(props: FiltersToggleProps) {
    super(props);

    this.filtersBtn = React.createRef();
    this.onDismiss = this.onDismiss.bind(this);
  }

  public static defaultProps = {
    isActive: false
  };

  public render() {
    const { isActive, searchResults, routeStore, buttonComponent, isFullWidth, label, a11yMessage, rfrr, stid } = this.props;
    const { isLoading, isError, sortAndFilter, searchCriteria } = searchResults;
    const regionId = searchCriteria && searchCriteria.regionId;
    const appliedFilterCount = sortAndFilter && sortAndFilter.options && sortAndFilter.options.appliedFilterCount;

    const filtersApplied = appliedFilterCount > 0;
    const filterOpenQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialog: 'filter' });
    const ButtonTracked = ClickTracker(buttonComponent);
    const extraProps =
      isActive && regionId
        ? {
            domRef: this.filtersBtn,
            tag: Link,
            to: {
              pathname: routeStore.pathname,
              search: filterOpenQuery
            }
          }
        : {};

    const buttonText = (
      <span>
        {filtersApplied && (
          <span>
            <strong aria-hidden="true" className="uitk-type-100 uitk-type-medium pwa-theme--color-white tools__filter-count">
              {appliedFilterCount}
            </strong>
            <span className="is-visually-hidden">
              <LocalizedText message={a11yMessage} data={[appliedFilterCount]} />
            </span>
          </span>
        )}
        <LocalizedText message={label} />
      </span>
    );

    return (
      <React.Fragment>
        <ButtonTracked
          data-stid={stid}
          disabled={!isActive || isLoading || isError || null}
          linkName="Launch filters takeover"
          rfrr={rfrr}
          icon={filtersApplied ? null : 'tune'}
          text={buttonText}
          isFullWidth={isFullWidth}
          {...extraProps}
        />
        <QueryRoute query={{ pwaDialog: 'filter' }}>
          <Layer id="tools-filterdrawer" onDismiss={this.onDismiss}>
            <FiltersDialog searchCriteria={searchResults.searchCriteria} searchResults={searchResults} onDismiss={this.onDismiss} />
          </Layer>
        </QueryRoute>
      </React.Fragment>
    );
  }

  private onDismiss(): void {
    const { routeStore } = this.props;

    if (routeStore && typeof routeStore.goBack === 'function') {
      routeStore.goBack();
    }

    if (this.filtersBtn.current && typeof this.filtersBtn.current.focus === 'function') {
      this.filtersBtn.current.focus();
    }
  }
}
